import styles from './contest.module.css';
import { useT } from '@shared/i18n';
export const Contest = () => {
	const t = useT();
	return (
		<section className={styles['contest']}>
			<iframe title={t('template.poets.contest')} src="https://www.pw.org/grants" />
		</section>
	);
};
